import Image from 'next/image';
import VehicleNotFound from 'public/static/images/srp/VehicleNotFound.svg';
import Close from 'public/static/images/srp/Close.svg';
import { colors, screen } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

interface VehicleNotFoundBannerProps {
  onClose?: () => void;
}

export default function VehicleNotFoundBanner({
  onClose,
}: VehicleNotFoundBannerProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="vehicle-not-found-banner">
      <Image src={VehicleNotFound} alt="vehicle-not-found-icon" width={26} height={24} />
      <div className="vehicle-not-found-text">{t('vehicleNotFoundBanner.header')}</div>
      <button data-testid="close-button" className="close-button" onClick={onClose}>
        <Image src={Close} alt="close-icon" width={20} height={20} />
      </button>
      <style jsx>{`
        .vehicle-not-found-banner {
          padding-left: 16px;
          min-height: 60px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          background-color: ${colors.BLACK};
          width: 100%;
        }

        .vehicle-not-found-text {
          color: ${colors.WHITE};
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          margin-left: 16px;
          margin-right: 36px;
        }

        .close-button {
          position: absolute;
          right: 16px;
          padding: 0;
          background-color: transparent;
          border: none;
        }

        @media (max-width: ${screen.mobileMax}) {
          .vehicle-not-found-text {
            width: 256px;
          }

          .vehicle-not-found-banner {
            height: 92px;
          }
        }
      `}</style>
    </div>
  );
}
